import { File as FileIcon, XIcon } from "lucide-react";
import { formatFileSize } from "@/utils/file";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

type UploadedFilePreviewProps = {
  file: File;
  onClick: () => void;
};

const UploadedFilePreview = ({ file, onClick }: UploadedFilePreviewProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const isImage = file.type.startsWith("image/");

  useEffect(() => {
    if (!isImage) return;
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file, isImage]);

  return (
    <div className="rounded-md text-neutral-500 flex items-center justify-between w-full gap-4 pl-4 border overflow-hidden">
      <div className="flex items-center gap-4 py-2">
        {isImage && previewUrl ? (
          <img
            src={previewUrl}
            alt={file.name}
            className="h-[64px] w-[64px] object-cover rounded"
          />
        ) : (
          <FileIcon size={36} />
        )}
        <div>
          <p className="text-sm font-medium text-neutral-700">{file.name}</p>
          <p className="text-xs">{formatFileSize(file.size / 1000)}</p>
        </div>
      </div>
      <Button onClick={onClick} variant="ghost" size="icon">
        <XIcon size={18} />
      </Button>
    </div>
  );
};

export default UploadedFilePreview;
